import i18n from "@client-shared/lib/i18n";
import { AxiosRequestConfig } from "axios";
import { axios } from ".";
import { AllParamsConfigResponse } from "../../providers/config/types";
import { handleDisplayErrorData } from "./utilities/handleDisplayErrorData";

const CONFIG_BASE_URL = "/api/v1/services/bc-services/config";

export const getAllParamConfig = async (vendorRegion: string, countryCode?: string | null) => {
  const url = `${CONFIG_BASE_URL}`;
  const config: AxiosRequestConfig = {
    params: { region: vendorRegion, ...(countryCode && { countryCode }) },
  };

  try {
    const response = await axios.get<{ data: AllParamsConfigResponse }>(url, config);
    return response.data.data;
  } catch (e) {
    console.log("Error in fetching region config", e);
    handleDisplayErrorData(i18n.t("apiErrorMessages.getAllConfig.message"), i18n.t("apiErrorMessages.getAllConfig.title"), e as Error);
    throw e;
  }
};
